import type { HTMLAttributes, ReactNode } from "react";

export interface InlineErrorProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
}

export function InlineError({
  children,
  className,
  ...props
}: InlineErrorProps) {
  const classes = ["marker-inline-error"];
  if (className) {
    classes.push(className);
  }

  return (
    <p className={classes.join(" ")} role="alert" {...props}>
      {children}
    </p>
  );
}

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  label?: string;
}

export function Spinner({
  className,
  label = "Loading",
  ...props
}: SpinnerProps) {
  const classes = ["marker-spinner"];
  if (className) {
    classes.push(className);
  }

  return (
    <span
      aria-label={label}
      className={classes.join(" ")}
      role="status"
      {...props}
    />
  );
}
